import { enum as bannerCustomContentIds } from '../../../../../../enums/banner-custom-content-ids';

import ReviewsOnOfferhubsBanner from './reviews-on-offerhubs';

export default function getBanner(contentId) {
	switch (contentId) {
		case bannerCustomContentIds['reviews-on-offerhubs']:
			return ReviewsOnOfferhubsBanner;
	}
}



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/banner/custom-banners/index.js